<p-toast [baseZIndex]="12000"></p-toast>
<div class="ui-g fondo">
  <div class="cardGray3 ui-g-12 ui-md-8 ui-lg-6" style="margin: 3% auto; padding: 2%; box-shadow: 0px 10px 15px -3px rgba(0,0,0,0.1),0px 10px 15px -3px rgba(0,0,0,0.1);">
    <div class="ui-g-12 ui-md-12 ui-sm-12 ui-grid" style="padding: 0;">
        <div class="ui-g-12 ui-md-12 ui-sm-12" style="align-items: center; display: flex; padding: 0;">
            <img style="margin: 2% auto; width: 100px;" src="assets/layout/images/rpn-web/logoRPN.png">
        </div>
        <div class="ui-g-12 ui-md-12 ui-sm-12" style="padding-bottom: 0;">
            <h2 class="title">Iniciar sesión</h2>
        </div>
    </div>
       <p-toast ></p-toast>
       <div class="ui-g-12" style="padding-top: 0;">
            <!--<p-messages></p-messages>-->
            <div class="ui-g-12">
                <p-dropdown [options]="items" [(ngModel)]="countryTitle"  placeholder="Elige su país:" optionLabel="descriptionCountry" [showClear]="true" [virtualScroll]="false" [itemSize]="60" [filter]="false"></p-dropdown>
                <!--<p-message severity="error" text="país es requerido"></p-message>-->
            </div>
            <br />
            <div class="ui-g-12">
                <input id="float-input" [(ngModel)]="card" type="text" size="50" placeholder="Número de carné o empleado:" pInputText >
                <!--<p-message severity="error" text="número de carné es requerido" ></p-message>-->
            </div>
            <br />
            <div class="ui-g-12 ui-fluid">
                <p-calendar [(ngModel)]="datetmp" dateFormat="dd/mm/yy" placeholder="Fecha de nacimiento" yearNavigator="true" [yearRange]="yearRange" monthNavigator="true"  (keyup)="onKeyDate($event)"></p-calendar>
                <!--<p-message severity="error" text="fecha de nacimiento es requerido"></p-message>-->
            </div>
           
            <div class="ui-g-12 ui-grid" style="display: flex; padding-bottom: 0;">
                <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
                <div class="ui-g-12 ui-md-6 ui-lg-6 ui-fluid" style="padding: 0;">
                    <div class="ui-g-12 ui-grid Npd">
                        <div class="ui-g-8"><h4 style="text-align: center; margin: 0; font-weight: 700;">Recordar datos </h4></div>
                        <div class="ui-g-4">
                            <p-inputSwitch  (onChange)="handleChange($event)" [ngModel]="countryTitle" ></p-inputSwitch> 
                        </div>
                    </div>
                </div>
                <div class="ui-g-1 ui-md-3 ui-lg-3"></div>
            </div>
            <div class="ui-g-12 ui-grid" style="display: flex; padding: 0;">
                <div class="p-col-12 p-lg-6 ui-fluid mg-btn"> <button pButton type="button" (click)="Login()" label="Ingresar"  style="color:whitesmoke;" class="ui-button-secondary btn"></button></div>
            </div>
            
            <p-dialog [(visible)]="display" [style]="{width: '50vw'}"  style="border: none;">
                <div style="display: flex; align-items: center;">
                    <img style="margin: 0 auto; width: 60px;" src="assets/images/web.png">  
                </div>
                <h2 style="text-align: center;">Conozca la nueva versión <br> del portal RPN</h2>
                <h4 style="text-align: center; color: #073c8f; font-weight: 500;">¡Ahora podrá visualizar más información y realizar más gestiones de su seguro de gastos médicos!</h4>
            </p-dialog>    
        </div>
    <div class="progress-spinner" *ngIf="env.isContentLoading">
      <img src="assets/images/Logo-1.gif" alt="" width="300px">
    </div>

    <div class="p-col-12 p-md-12 p-lg-12" style="text-align: center; margin: 0 auto;" >
        <div class="p-col hov" *ngIf="countryReq != 'HN'">
            <a  href="/cannot-login" >¿No puedo ingresar?</a>
        </div>
        <div class="p-col hov" *ngIf="countryReq != 'HN'">
            <a  href="/forgot-id">Olvidé mi carnet o número de empleado</a>
        </div>
        <div class="p-col"><h4>Version: 2.5.7</h4></div>
    </div>
  </div>
</div>

